export function fullWidthCarousel() {
    const $slider = $(".full-width-carousel");
    $slider.each(function () {
        let $this = $(this);
        $this.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            infinite: true,
            arrows: false,
            fade: true,
            dots: true,
            mobileFirst: true,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        adaptiveHeight: false,
                    }
                },
            ]
        });
    });

    $slider.on("click", function () {
        $(this).slick("slickNext");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/fullWidthCarousel.js